/** @format */

import React from "react";
import styled from "styled-components";
import { TModalitaPresenze } from "../../../../redux-modules/declarations/maps/turniSettimana";
import {
  descrizioneSegnalazione,
  dettaglioSegnalazione,
  TContestoSegnalazione,
  TUnitaPresenze,
} from "../format";

interface Props {
  contesto: TContestoSegnalazione;
  modalita: TModalitaPresenze;
  unita: TUnitaPresenze;
}

/**
 * Cosa dice una segnalazione, nel pannello della giornata e in "Da gestire". Timbrature da approvare
 * e richieste in attesa in righe (Turno, Timbrata, Scostamento, Richiesta) con, sotto, l'effetto
 * dell'accettazione; le altre segnalazioni restano una frase.
 */
export const DettaglioSegnalazione = ({ contesto, modalita, unita }: Props): JSX.Element => {
  const dettaglio = dettaglioSegnalazione(contesto, modalita, unita);
  if (!dettaglio) return <span>{descrizioneSegnalazione(contesto, unita)}</span>;

  return (
    <Stile>
      <dl>
        {dettaglio.righe.map(r => (
          <React.Fragment key={r.etichetta}>
            <dt>{r.etichetta}</dt>
            <dd>{r.valore}</dd>
          </React.Fragment>
        ))}
      </dl>
      {dettaglio.esito && <p className="esito">{dettaglio.esito}</p>}
    </Stile>
  );
};

const Stile = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  dl {
    display: grid;
    grid-template-columns: 92px 1fr;
    gap: 2px 10px;
    margin: 0;
    font-size: 13px;
    line-height: 1.45;
  }
  dt {
    font-weight: 500;
    opacity: 0.8;
  }
  dd {
    margin: 0;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
  }
  .esito {
    margin: 0;
    padding: 6px 9px;
    border-radius: 7px;
    background: rgba(255, 255, 255, 0.7);
    box-shadow: inset 0 0 0 1px rgba(126, 24, 48, 0.12);
    font-size: 13px;
    font-weight: 700;
  }
`;
